import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { takeUntil } from 'rxjs/operators';
import { SaComponent } from 'smartauction-frontend-micro-library';
import { NgClass } from '@angular/common';

export interface BannerConfig {
  showUndo: boolean;
  text: string;
  mode: 'confirmation' | 'error' | 'none';
  showIcon: boolean;
  showSuccessIcon: boolean;
  showErrorIcon: boolean;
}

@Component({
    selector: 'app-sell-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    imports: [TranslocoDirective, NgClass]
})
export class BannerComponent extends SaComponent implements OnInit {
  @Input() bannerConfig: BannerConfig = {
    showUndo: false,
    text: '',
    mode: 'none',
    showIcon: false,
    showSuccessIcon: false,
    showErrorIcon: false
  };
  @Input() translationPath;
  @Output() close = new EventEmitter();
  @Output() undo = new EventEmitter();

  constructor(
    private readonly translocoService: TranslocoService
  ) {
    super();
  }

  undoRemove(e) {
    e.preventDefault();
    this.undo.emit();
  }
  
  ngOnInit():void {
    this.getTranslations();
  }

  getTranslations(): void {
    if (this.translationPath) {
      this.translocoService.selectTranslate(this.translationPath).pipe(takeUntil(this.destroyed$)).subscribe((translation) => {
        this.bannerConfig.text = translation;
      });
    }
  }
}
